import { BBox2D } from "./BBox2D";
import { PeliasFeature } from "./PeliasFeature";

/**
 * 1. Filter out features with duplicate names preferencing larger bboxes.
 * 2. Apply mappings 
 * 3. Trim any bboxes that cross the antimeridian (eg. Fiji, Russia)
 */
export function sanitize(features: PeliasFeature[]): PeliasFeature[] {
    const hashset = features
        .map(feature => {
            const { bbox } = feature;

            if (BBox2D.crossesAntimeridian(bbox)) {
                feature.bbox = BBox2D.max(...BBox2D.antimeridianSplit(bbox!));
            }

            return feature;
        })
        .reduce<{ [key: string]: PeliasFeature }>((hash, feature) => {
            const { properties: { label }, bbox } = feature;

            const current = hash[label];

            if (!current || BBox2D.area(bbox) > BBox2D.area(current.bbox)) {
                hash[label] = feature;
            }

            return hash;
        }, {});

    return Object.values(hashset);
}